import { apiPost, unwrapData } from './helpers'

const PATH = 'weightloss/pricing'

export default {
  /**
   * Preview de precios antes de guardar visita.
   * @returns {Promise<object>} pricing
   */
  quote: data =>
    apiPost(`${PATH}/quote`, data).then(res => {
      const payload = unwrapData(res)
      // Acepta { pricing }, pricing directo, o anidado data.pricing
      if (payload?.pricing) return payload.pricing
      if (payload?.data?.pricing) return payload.data.pricing
      if (payload && (payload.total != null || payload.main_line)) return payload
      return payload
    }),
}
